// ── DESIGN TOKENS — matched to ClarionCallmobile theme ───────
export const T = {
  // Primary — Deep maroon navy (matches mobile navySection)
  navy:"#3D0A0A", navyMid:"#5A1010", navyLight:"#7A1A1A",

  // Gold (tier badges, milestones)
  gold:"#C9A84C", goldLight:"#DFC06A", goldPale:"#FBF5DC",

  // Orange — primary action (buttons, CTAs)
  orange:"#E8621A", orangeLight:"#F07B35", orangePale:"#FEF0E6",

  // Neutrals — warm cream light theme
  white:"#ffffff", cream:"#FBF5EC",
  grey50:"#F3ECE0", grey100:"#E0D5C5", grey200:"#CEC3B0", grey300:"#B8B0A0",
  grey400:"#8A8AA8", grey500:"#6A6A88", grey600:"#4A4A6A", grey700:"#2A2A4A", grey800:"#1C1C2E",

  // Status
  green:"#2E7D32", greenBg:"#eaf4ef",
  amber:"#c47a1a", amberBg:"#fef4e6",
  red:"#C62828", redBg:"#fef2f2",
  blue:"#1565C0", blueBg:"#eff6ff",
  purple:"#6d28d9", purpleBg:"#f5f3ff",
  whatsapp:"#25d366",
};

// ── PERSON TYPES ───────────────────────────────────────────
export const PERSON_TYPES = {
  cnom:       { label:"CNOM Member",        color:T.blue,    bg:T.blueBg,    icon:"🔵" },
  clarion:    { label:"Clarion Call",        color:T.gold,    bg:T.goldPale,  icon:"🟡" },
  occasional: { label:"Occasional Visitor",  color:T.grey600, bg:T.grey100,   icon:"⚪" },
  visitor:    { label:"New Visitor",         color:T.green,   bg:T.greenBg,   icon:"👋" },
};

// ── SERVICE TYPES ──────────────────────────────────────────
export const CNOM_SERVICES    = ["Sunday Main Service","Midweek/Wednesday Service","Friday Prayer/Vigil","Prayer & Fasting","Children's Service"];
export const CLARION_SERVICES = ["Clarion Call Network"];
export const ALL_SERVICES     = [...CNOM_SERVICES, ...CLARION_SERVICES, "Special Service","Conference","Other"];

// ── GIVING CATEGORIES ──────────────────────────────────────
export const CNOM_GIVING_TYPES    = ["Tithe","Offering","Altar Commitment","Sacrificial Seed"];
export const CLARION_GIVING_TYPES = ["Partnership","Sacrificial Seed","Offering","Income Generation Initiatives","Training"];

// ── EXPENSE CATEGORIES ─────────────────────────────────────
export const EXPENSE_CATEGORIES = ["Utilities","Salaries","Equipment","Events","Transport","Printing","Maintenance","Tithe Disbursement","Other"];

// ── VENUE ──────────────────────────────────────────────────
export const SPACES        = ["Main 2nd Floor Hall","Training Room 1","Training Room 2","Board Room","4th Floor Hall","4th Floor Office"];
export const MEDIA_SERVICES = ["TV Screen Projection","Live / Social Media Coverage","Video Capture & Recording","Public Address (PA) System Hire","Media Operators Hire","Keyboard Operator Hire"];

// ── ROSTER ROLES ───────────────────────────────────────────
export const ROSTER_ROLES = ["Preacher / Teacher","Worship / Music","Ushers / Protocol","Offering / Finance","Sound & Projection","Intercessors / Prayer Team","Security","Hospitality & Housekeeping","Children's Ministry"];

// ── NAV MODULES ────────────────────────────────────────────
export const NAV_MODULES = [
  // Home
  { id:"dashboard",      label:"Dashboard",         icon:"⊞",  section:"Home" },

  // People
  { id:"people",         label:"People Directory",  icon:"👥", section:"People" },
  { id:"attendance",     label:"Attendance",        icon:"📅", section:"People" },
  { id:"cellgroups",     label:"Cell Groups",       icon:"🏠", section:"People" },
  { id:"events",         label:"Events",            icon:"📆", section:"People" },
  { id:"roster",         label:"Duty Roster",       icon:"📋", section:"People" },

  // The Word
  { id:"messages",       label:"Rhema",             icon:"🎙️", section:"The Word" },
  { id:"devotionals",    label:"Devotion & Prayer", icon:"✝️", section:"The Word" },
  { id:"academy",        label:"Training Academy",  icon:"🎓", section:"The Word" },

  // Outreach
  { id:"soulwinning",    label:"Soul Winning",      icon:"🌍", section:"Outreach" },
  { id:"sow",            label:"Sow & Grow",        icon:"🌱", section:"Outreach" },
  { id:"collaborate",    label:"Conversations",     icon:"💬", section:"Outreach" },

  // Pastoral
  { id:"talktopastor",   label:"Talk to Pastor",    icon:"🙏", section:"Pastoral" },
  { id:"goals",          label:"Growth Goals",      icon:"🎯", section:"Pastoral" },

  // Operations
  { id:"financials",     label:"Financials",        icon:"💰", section:"Operations" },
  { id:"hr",             label:"HR & Staff",        icon:"👔", section:"Operations" },
  { id:"content",        label:"Comms",             icon:"📡", section:"Operations" },
  { id:"permissions",    label:"User Management",   icon:"🔐", section:"Operations" },
];

// ── SPIRITUAL GIFTS ────────────────────────────────────────
export const SPIRITUAL_GIFTS = [
  "Apostle","Prophet","Evangelist","Pastor","Teacher",
  "Tongues","Interpretation of Tongues","Prophecy","Word of Knowledge","Word of Wisdom",
  "Faith","Healing","Miracles","Discernment of Spirits","Helps","Administration",
  "Giving","Leadership","Mercy","Exhortation","Serving",
  "Intercession","Hospitality","Worship & Music","Creative Arts"
];

// ── KINGDOM DOMAINS (Myles Munroe — 7 Mountains) ──────────
export const KINGDOM_DOMAINS = [
  "The Church & Ministry",
  "Family & Marriage",
  "Education & Academia",
  "Business & Finance",
  "Government & Law",
  "Media & Communications",
  "Arts, Sports & Entertainment"
];

// ── SPIRITUAL MILESTONES ───────────────────────────────────
export const MILESTONES = [
  { key:"saved",               label:"Born Again (Saved)",              icon:"✝️" },
  { key:"water_baptism",       label:"Water Baptised",                  icon:"💧" },
  { key:"holy_spirit_baptism", label:"Holy Spirit Baptism (Tongues)",   icon:"🔥" },
  { key:"foundations_course",  label:"Completed Foundations Course",    icon:"📖" },
  { key:"gifts_identified",    label:"Spiritual Gifts Identified",      icon:"🎁" },
  { key:"cell_group",          label:"Joined a Cell / Home Group",      icon:"🏠" },
  { key:"serving",             label:"Serving in a Ministry Dept",      icon:"🛠️" },
  { key:"discipling",          label:"Discipling Someone",              icon:"🔗" },
  { key:"led_to_christ",       label:"Led Someone to Christ",           icon:"🌍" },
];

// ── ENGAGEMENT TIERS ───────────────────────────────────────
export const ENGAGEMENT_TIERS = {
  seedling:    { label:"Seedling",    color:"#1a6b3c", bg:"#eaf4ef", icon:"🌱", min:0,  max:24 },
  growing:     { label:"Growing",     color:"#c47a1a", bg:"#fef4e6", icon:"🌿", min:25, max:49 },
  fruitful:    { label:"Fruitful",    color:"#1e5fa8", bg:"#eff6ff", icon:"🌳", min:50, max:74 },
  multiplying: { label:"Multiplying", color:"#c9972a", bg:"#fdf3dc", icon:"🌾", min:75, max:100 },
};

// ── HEALTH DIMENSIONS (12) ─────────────────────────────────
export const HEALTH_DIMENSIONS = [
  { key:"foundation",   label:"Foundation & Identity",     icon:"⚓", source:"Wommack",            description:"Members baptized, completed Foundation Course, or core doctrinal training" },
  { key:"word",         label:"Word & Bible Study",        icon:"📖", source:"Oyedepo",            description:"Members with active Bible study streaks or weekly study completions logged" },
  { key:"prayer",       label:"Prayer & Fasting",          icon:"🙏", source:"African Charismatic", description:"Members on prayer watch, corporate prayer attendance, or fasting days observed" },
  { key:"supernatural", label:"Supernatural Lifestyle",    icon:"⚡", source:"Bill Johnson",        description:"Testimonies of miracles, healings, prophetic words, and answered prayer logged" },
  { key:"loyalty",      label:"Loyalty & Commitment",      icon:"🤝", source:"Heward-Mills",        description:"Members attending 3+ Sundays/month or with a consistent attendance streak" },
  { key:"community",    label:"Community & Cell Groups",   icon:"🏠", source:"NCD",                description:"Members placed in an active cell group, or total number of groups running" },
  { key:"service",      label:"Service & Ministry",        icon:"🛠️", source:"Munroe",              description:"Members actively serving in a ministry department or events fully staffed" },
  { key:"discipleship", label:"Discipleship Chain",        icon:"🔗", source:"Wommack",            description:"Members in an active discipleship pair or with an assigned discipler/mentor" },
  { key:"evangelism",   label:"Evangelism & Soul Winning", icon:"🌍", source:"Heward-Mills",        description:"Salvations logged, gospel conversations had, or members active in outreach" },
  { key:"stewardship",  label:"Stewardship & Giving",      icon:"💛", source:"Oyedepo",            description:"Consistent givers, % of members tithing regularly, or first-time givers this period" },
  { key:"purpose",      label:"Purpose & Calling",         icon:"🎯", source:"Munroe",              description:"Members with a completed calling profile — spiritual gifts, kingdom domain, calling statement" },
  { key:"character",    label:"Character & Fruit",         icon:"🍎", source:"Universal",           description:"Discipleship milestone completions logged — markers of spiritual maturity" },
];

// ── SOUL WINNING TYPES ─────────────────────────────────────
export const SW_EVENT_TYPES = [
  { key:"conversation", label:"Shared the Gospel",  description:"You explained salvation — even if they didn't respond yet" },
  { key:"invitation",   label:"Invited to Church",  description:"You personally invited someone to attend a service or event" },
  { key:"salvation",    label:"Led to Christ 🙌",   description:"They prayed the salvation prayer and accepted Christ" },
  { key:"follow_up",    label:"Follow-Up Visit",    description:"A return contact — call, visit, or meeting with a previous lead" },
];

export const SW_OUTCOMES = [
  { key:"prayed_together", label:"Prayed Together",     description:"You prayed with them — they may not have committed yet" },
  { key:"invited",         label:"Accepted Invitation", description:"They agreed to attend church or a church event" },
  { key:"visited_church",  label:"Visited Church",      description:"They actually showed up at a service" },
  { key:"became_member",   label:"Became a Member",     description:"They are now registered as a member in the system" },
  { key:"ongoing",         label:"Still Following Up",  description:"Conversation is open — you are continuing to reach them" },
];

// ── VISIT TYPES ────────────────────────────────────────────
export const VISIT_TYPES = [
  { key:"home_visit",     label:"Home Visit" },
  { key:"call",           label:"Phone / Video Call" },
  { key:"hospital",       label:"Hospital / Sick Visit" },
  { key:"social",         label:"Social / Fellowship" },
  { key:"crisis_support", label:"Crisis Support" },
];

// ── TESTIMONY CATEGORIES ───────────────────────────────────
export const TESTIMONY_CATEGORIES = [
  { key:"healing",        label:"Healing & Health" },
  { key:"answered_prayer",label:"Answered Prayer" },
  { key:"financial",      label:"Financial Breakthrough" },
  { key:"salvation",      label:"Salvation" },
  { key:"supernatural",   label:"Supernatural Encounter" },
  { key:"other",          label:"Other" },
];

// ── GROWTH GOAL UNITS ──────────────────────────────────────
export const UNIT_HINTS = {
  members:    "A headcount of people — e.g. '150 members in weekly Bible study'",
  percentage: "A proportion of the church — e.g. '65% of members giving regularly'",
  count:      "A total of activities — e.g. '40 salvations logged this quarter'",
  score:      "A health score target — e.g. 'Raise this dimension from 45 to 70 points'",
};

export const GOAL_UNITS = [
  { key:"members",    label:"Members" },
  { key:"percentage", label:"Percentage (%)" },
  { key:"count",      label:"Count (events / salvations)" },
  { key:"score",      label:"Health Score Points" },
];

export const DIMENSION_GUIDE = {
  foundation:   { members:"Members baptized or who completed Foundation Course", percentage:"% of members who've completed foundation/doctrinal training", count:"Foundation classes held or baptism services conducted", score:"Raise Foundation health score e.g. from 45 → 70 points" },
  word:         { members:"Members completing weekly Bible study consistently", percentage:"% of members with an active Bible study streak", count:"Study completions logged in the system this period", score:"Raise Word & Bible Study score e.g. from 50 → 75 points" },
  prayer:       { members:"Members signed up on the prayer watch roster", percentage:"% of members who attended corporate prayer this month", count:"Prayer meetings held or fasting days observed as a church", score:"Raise Prayer & Fasting score e.g. from 40 → 65 points" },
  supernatural: { members:"Members who've submitted at least one supernatural testimony", percentage:"% of members who've logged a testimony of healing or miracle", count:"Total testimonies logged — miracles, healings, answered prayer", score:"Raise Supernatural Lifestyle score e.g. from 35 → 60 points" },
  loyalty:      { members:"Members with 80%+ attendance this quarter", percentage:"% of members attending 3+ Sundays per month — best measure", count:"Not ideal — use Members or Percentage for this dimension", score:"Raise Loyalty & Commitment score e.g. from 55 → 80 points" },
  community:    { members:"Members placed in an active cell/home group", percentage:"% of total members currently in a cell group — best measure", count:"Number of active cell groups currently running", score:"Raise Community & Cell Groups score e.g. from 45 → 70 points" },
  service:      { members:"Members actively serving in a ministry department", percentage:"% of members with an active service role", count:"Services or events fully staffed this month", score:"Raise Service & Ministry score e.g. from 50 → 75 points" },
  discipleship: { members:"Members with an assigned discipler or in an active pair", percentage:"% of members currently in a discipleship relationship — best measure", count:"Discipleship meetings or care visits logged this period", score:"Raise Discipleship Chain score e.g. from 40 → 65 points" },
  evangelism:   { members:"Members who've logged a soul winning encounter this month", percentage:"% of members active in outreach this period", count:"Salvations logged — most natural measure for this dimension", score:"Raise Evangelism score e.g. from 45 → 70 points" },
  stewardship:  { members:"Consistent givers this quarter", percentage:"% of members giving regularly — clearest measure", count:"First-time givers this month", score:"Raise Stewardship & Giving score e.g. from 50 → 75 points" },
  purpose:      { members:"Members with a completed calling profile (gifts + domain + statement)", percentage:"% of members with a calling statement on their profile", count:"Prophetic Blueprints generated or calling sessions completed", score:"Raise Purpose & Calling score e.g. from 35 → 60 points" },
  character:    { members:"Members who've completed all 9 discipleship milestones", percentage:"% of members past Milestone 5 (serving stage)", count:"Total milestone completions logged across the church — best measure", score:"Raise Character & Fruit score e.g. from 40 → 65 points" },
};

// ── HELPERS ────────────────────────────────────────────────
export const todayStr   = () => new Date().toISOString().slice(0,10);
export const daysSince  = d  => d ? Math.floor((Date.now() - new Date(d)) / 86400000) : 999;
export const fmtKES     = n  => `KES ${Number(n || 0).toLocaleString('en-KE', { minimumFractionDigits:2, maximumFractionDigits:2 })}`;
export const initials   = n  => (n||"?").split(" ").map(x=>x[0]).join("").slice(0,2).toUpperCase();
export const avatarColor = n => {
  const cols = [T.navyMid,"#6d4c41","#2e7d32","#1565c0","#6a1b9a","#ad1457","#00695c","#e65100"];
  return cols[(n||"A").charCodeAt(0) % cols.length];
};

export const openWA = (phone, msg) =>
  window.open(`https://wa.me/${phone.replace(/\D/g,"")}?text=${encodeURIComponent(msg)}`, "_blank");

export const bookingTotal = b => {
  const sp = (b.spaces||[]).reduce((s,x) => s + (Number(x.amount)||0), 0);
  const md = (b.media||[]).reduce((s,x)  => s + (Number(x.amount)||0), 0);
  return { spaces:sp, media:md, grand:sp+md, balance:(sp+md)-(Number(b.deposit)||0) };
};

// ── FOLLOW-UP LOGIC ────────────────────────────────────────
export const getCnomMissed = (person, attendance) => {
  const joinDate = person.join_date || person.created_at?.slice(0, 10);
  const cnomAtt = [...(attendance||[])]
    .filter(a => CNOM_SERVICES.includes(a.service))
    .filter(a => !joinDate || a.date >= joinDate) // ignore services before person was added
    .sort((a,b) => b.date.localeCompare(a.date))
    .slice(0, 3);
  let missed = 0;
  for (const a of cnomAtt) {
    if (!(a.present_ids||[]).includes(person.id)) missed++;
    else break;
  }
  return missed;
};

export const getPersonFlag = (person, attendance) => {
  const types  = person.types || [];
  const missed = getCnomMissed(person, attendance);
  if (types.includes("cnom") && missed >= 2) return { level:"red",   msg:`Missed ${missed} services` };
  if (types.includes("cnom") && missed === 1) return { level:"amber", msg:"Missed 1 service" };
  // Only flag on date-based rules if the date was actually recorded — never flag null dates
  if (types.includes("clarion") && person.last_clarion && daysSince(person.last_clarion) > 30)
    return { level:"amber", msg:`No Clarion Call ${daysSince(person.last_clarion)}d` };
  if (types.includes("occasional") && !types.includes("cnom") && !types.includes("clarion")
      && person.last_attended && daysSince(person.last_attended) > 21)
    return { level:"amber", msg:`Not seen ${daysSince(person.last_attended)}d` };
  if (types.includes("visitor") && person.visit_date && daysSince(person.visit_date) > 7
      && !person.followed_up)
    return { level:"amber", msg:"Follow-up overdue" };
  return null;
};

// ── WHATSAPP MESSAGE TEMPLATES ─────────────────────────────
export const waFollowUp = (person) => {
  const types = person.types || [];
  const name  = person.name.split(" ")[0];
  if (types.includes("cnom"))
    return `Hello ${name}! 🙏 This is CNOM Church. We've noticed you haven't been with us recently and we miss you! We'd love to see you this Sunday. God bless you!\n\n— Blessings from CNOM Church Family 🙏`;
  if (types.includes("clarion"))
    return `Hello ${name}! 🙏 This is CNOM Church / Clarion Call Network. We haven't seen you at our last gathering and wanted to reach out. Our next meeting is coming up — we'd love to have you!\n\n— Blessings from CNOM Church Family 🙏`;
  return `Hello ${name}! 🙏 Thank you for visiting CNOM Church. We'd love to see you again and get to know you better. Please join us this Sunday!\n\n— Blessings from CNOM Church Family 🙏`;
};
